import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuex, { mapGetters } from 'vuex'
import axios from './plugins/axios.js'
import VueMeta from 'vue-meta'

import vSelect from "vue-select";
import VueCroppie from 'vue-croppie';
import 'croppie/croppie.css' // import the croppie css manually


import moment from 'moment'
import 'moment/locale/ru';

import helpers from './helpers'

import './assets/scss/styles.scss'
Vue.component("v-select", vSelect);
Vue.use(VueCroppie);
Vue.use(axios);
Vue.config.productionTip = false


Vue.prototype.helpers = helpers
moment.locale('ru')
Vue.prototype.$m = moment

Vuex.Store.prototype.helpers = helpers

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

export const bus = new Vue();
bus.data = { result: [] }
new Vue({
  data: () => ({
    windowWidth: window.innerWidth,
   
  }),
  computed: {
    ...mapGetters(['user']),
    host() {
      return "";
    },
    analyticData() {
      let browser;
      if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
        browser = 'Opera';
      } else if (navigator.userAgent.indexOf("Edg") != -1) {
        browser = 'Edge';
      } else if (navigator.userAgent.indexOf("YaBrowser") != -1) {
        browser = 'Yandex Browser';
      } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        browser = 'Chrome';
      } else if (navigator.userAgent.indexOf("Safari") != -1) {
        browser = 'Safari';
      } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        browser = 'Firefox';
      } else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) //IF IE > 10
      {
        browser = 'IE';
      } else {
        browser = 'unknown';
      }
      return {
        browser: browser,
        device: this.getDeviceType(),
        os: this.getOS(),
        session_id: localStorage.getItem('sessionId') || "",
        url: document.location.origin + document.location.pathname,
        nova_id: this.mdmId,
        user_id: this.userId,
        dpl_id: this.$route.query.access || ""
      }

    },

    encodedEmail() {
      if (this.user && Object.keys(this.user).length) {
        return this.helpers.b64EncodeUnicode(this.user.email)
      }
      return ""
    },
    encodedIp() {
      if (this.user && Object.keys(this.user).length) {
        return this.helpers.b64EncodeUnicode(this.user.ip_address)
      }
      return ""
    },
    mdmId() {
      if (this.user && Object.keys(this.user).length) {
        return this.user.mdm_id
      }
      return ""
    },
    userId() {
      if (this.user && Object.keys(this.user).length) {
        return this.user.id
      }
      return ""
    },
    userDiseases() {
      if (this.user && Object.keys(this.user).length) {
        return this.user.diseases.map((el) => el.id)
      }
      return []
    },
    ymFields() {
      return {
        url: this.$route.fullPath,
        'UserID': this.encodedEmail,
        'IPAdress': this.encodedIp,
        'Areas': this.userDiseases,
        'MDMID': this.mdmId
      }
    },
    isMobile: function () {
      return this.windowWidth < 768;
    },
    isTablet: function () {
      return this.windowWidth < 1220 && this.windowWidth > 767;
    },
    ssoLinks() {
      let fasttrack = this.$route.query.fasttrack ? `&fasttrack=${this.$route.query.fasttrack}` : ''
      return {
        registration: `${process.env.VUE_APP_SSO_HOST}signup?source=${encodeURIComponent(window.location.href)}&next_url=${window.location.origin}/az-sso&back_url=${encodeURIComponent(window.location.href)}${fasttrack}`,
        login: `${process.env.VUE_APP_SSO_HOST}signin?source=${encodeURIComponent(window.location.href)}&next_url=${window.location.origin}/az-sso&back_url=${encodeURIComponent(window.location.href)}${fasttrack}`
      }
    },
    backetName() {
      return process.env.VUE_APP_BACKET_NAME
    }

  },
  methods: {
    getUniqueID() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      }
      return s4() + s4() + '-' + s4();
    },
    getOS() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
      }
      if (/android/i.test(userAgent)) {
        return "Android";
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      }
      if (/Macintosh/i.test(userAgent)) {
        return "MacOS";
      }
      if (/Windows/i.test(userAgent)) {
        return "Windows";
      }
      if (/Linux/i.test(userAgent)) {
        return "Linux";
      }

      return "Unknown OS";
    },
    getDeviceType() {
      const userAgent = navigator.userAgent;
      if (/Mobi|Android/i.test(userAgent)) {
        return "Mobile";
      }
      if (/Tablet|iPad/i.test(userAgent)) {
        return "Tablet";
      }
      return "Desktop";
    },
    
  },
  async mounted() {
    if (!localStorage.getItem('sessionId')) {
      localStorage.setItem('sessionId', this.getUniqueID())
    }
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })



  },
  watch: {
    '$route': {
      handler: async function (n, o) {
        if (o?.name && o.path !== n.path) {
          if (typeof ym !== 'undefined') {
            ym(91468266, 'hit', n.fullPath)
          }
          if (localStorage.getItem("profiling_shown")) {
            let count = parseInt(localStorage.getItem("profiling_shown"));
            localStorage.setItem("profiling_shown", count + 1);
          }
        }
        setTimeout(() => {
          document.querySelectorAll('video').forEach((v) => {
            v.setAttribute('controlsList', "nodownload")
            v.addEventListener("contextmenu", (event) => { event.preventDefault() });
          })
        }, 3000)
      },
      deep: true,
      immediate: true,
    },
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app')
